import routeInvites from './invites.route'
import routeUsers from './users.route'
import routeLogs from './logs.route'

export default [...routeInvites, ...routeUsers, routeLogs]
